// extracted by mini-css-extract-plugin
export default {"List":"P2Cl27gubxmG4jUt2Vos","List__Item":"n8PoQktFsh6cgPxHENwu","List__Item__Price":"ymXhclMwmH094ETQ7jFA","List__Item__Badge":"Nkr_BUFRXOy08j645dS2"};